<script lang="ts">
    import { tick } from "svelte"
    import inputfields from "./"
    export let currentChoices = null

    export let value: {
        [key: string]: number
    } = {}
    export let label: string
    export let values: { [key: string]: any }
    values = values || null

    let previewData: number[][] = []

    const fields = [
        {
            name: "mailboxTotalCount",
            widget: "number",
            label: "Wieviele Briefkästen benötigen Sie?",
            placeholder: "Geben Sie eine Zahl ein",
            defaultValue: 1,
        },
        {
            name: "mailboxHorizontalCount",
            widget: "number",
            label: "Horizontal",
            placeholder: "Geben Sie eine Zahl ein",
            defaultValue: 1,
        },
    ]

    const onTotalChanged = async (e: CustomEvent) => {
        await updateHorizontal()
    }

    const updateHorizontal = async () => {
        await tick()
        if (!value[fields[1].name]) {
            value[fields[1].name] = 1
        }
    }

    const onHorizontalChanged = (e: CustomEvent) => {
        if (!e.detail) {
            value[fields[1].name] = 1
        }
    }

    $: {
        // Prepare Preview Data
        previewData = []
        let row = 0
        if (value[fields[0].name] && value[fields[1].name]) {
            for (let i = 1; i <= value[fields[0].name]; i++) {
                if (!previewData[row]) {
                    previewData[row] = []
                }

                previewData[row].push(i)

                if (value[fields[1].name] > 1) {
                    if (i > 0 && i % value[fields[1].name] === 0) {
                        row++
                    }
                } else {
                    row++
                }
            }
        }
    }
</script>

<div class="mailbox-quantity-input">
    {#if label}
        <label for="">{label}</label>
    {/if}
    <div class="options">
        <div>
            <svelte:component
                this="{inputfields[fields[0].widget] || inputfields.default}"
                {...fields[0]}
                bind:value="{value[fields[0].name]}"
                on:input="{onTotalChanged}"
                {currentChoices}
            />

            <svelte:component
                this="{inputfields[fields[1].widget] || inputfields.default}"
                {...fields[1]}
                disabled="{!value[fields[0].name]}"
                bind:value="{value[fields[1].name]}"
                on:input="{onHorizontalChanged}"
                {currentChoices}
            />

            <div class="number-input">
                <label for="">Vertikal (wird automatisch berechnet)</label>
                <input bind:value="{previewData.length}" readonly />
            </div>
        </div>

        {#if value[fields[0].name]}
            <div class="preview">
                {#key value}
                    <div class="preview-content">
                        <div class="mailboxes">
                            {#each previewData as row (row)}
                                <div class="mailbox-row">
                                    {#each row as i (i)}
                                        <div class="mailbox-example">
                                            <div class="mailbox-example-input"></div>
                                            <div class="mailbox-example-number">
                                                {i}
                                            </div>
                                        </div>
                                    {/each}
                                </div>
                            {/each}
                        </div>
                    </div>
                {/key}
            </div>
        {/if}
    </div>
</div>
